var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclipsedVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8182 56L26.3636 49.9048L19.8182 48.381L20.4545 41.3333L16 36L20.4545 30.6667L19.8182 23.619L26.3636 22.0952L29.8182 16L36 18.7619L42.1818 16L45.6364 22.0952L52.1818 23.619L51.5455 30.6667L56 36L51.5455 41.3333L52.1818 48.381L45.6364 49.9048L42.1818 56L36 53.2381L29.8182 56ZM34.0909 42.7619L44.3636 32L41.8182 29.2381L34.0909 37.3333L30.1818 33.3333L27.6364 36L34.0909 42.7619Z",
    fill: "#ED6E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclipsedVerifiedIcon);
export default __webpack_public_path__ + "static/media/eclipsed-verified-icon.f568c489ac2af2850b3f741fe2933df1.svg";
export { ForwardRef as ReactComponent };